import { config } from "@/shared/lib/config";
import { fetcher } from "@/shared/lib/fetcher";
import type { AdminNotificationsSummary } from "../../domain/types";

export const notificationsApi = {
  getSummary(): Promise<AdminNotificationsSummary> {
    return fetcher.get<AdminNotificationsSummary>(
      `${config.apiUrl}/notifications/summary`,
    );
  },
};
